import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { TESTIMONIALS } from "@/lib/site-data";
import { Star, ChevronLeft, ChevronRight, Quote } from "lucide-react";

export default function Testimonials() {
  const [i, setI] = useState(0);
  const next = () => setI((p) => (p + 1) % TESTIMONIALS.length);
  const prev = () => setI((p) => (p - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);

  useEffect(() => {
    const id = setInterval(next, 7000);
    return () => clearInterval(id);
    // eslint-disable-next-line
  }, []);

  const t = TESTIMONIALS[i];
  return (
    <section data-testid="testimonials-section" id="testimonials" className="py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center">
        <div className="text-[11px] uppercase tracking-[0.22em] text-[#D4AF37] font-semibold">Client Stories</div>
        <h2 className="font-heading mt-3 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight">
          Trusted by leading <span className="gold-gradient-text font-medium">jewellers & institutions</span>.
        </h2>

        <div className="relative mt-14">
          <Quote className="w-10 h-10 text-[#D4AF37]/50 mx-auto" strokeWidth={1.2} />
          <AnimatePresence mode="wait">
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 18 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -12 }}
              transition={{ duration: 0.5 }}
              className="font-heading mt-6 text-xl sm:text-2xl lg:text-3xl font-light text-[#0A0A0A] leading-relaxed max-w-3xl mx-auto"
              data-testid={`testimonial-${i}`}
            >
              "{t.quote}"
            </motion.blockquote>
          </AnimatePresence>
          <div className="mt-8 flex items-center justify-center gap-1.5">
            {[...Array(5)].map((_, k) => (
              <Star key={k} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
            ))}
          </div>
          <div className="mt-4">
            <div className="font-heading text-base font-medium text-[#0A0A0A]">{t.name}</div>
            <div className="text-xs uppercase tracking-[0.18em] text-[#4B5563] mt-1">{t.role}</div>
          </div>

          <div className="mt-10 flex items-center justify-center gap-3">
            <button
              onClick={prev}
              data-testid="testimonial-prev"
              className="w-10 h-10 rounded-full border border-[#E5E5E5] hover:border-[#D4AF37] flex items-center justify-center transition-colors"
            >
              <ChevronLeft className="w-4 h-4" strokeWidth={1.6} />
            </button>
            <div className="flex items-center gap-2">
              {TESTIMONIALS.map((_, k) => (
                <button
                  key={k}
                  onClick={() => setI(k)}
                  data-testid={`testimonial-dot-${k}`}
                  className={`h-1.5 rounded-full transition-all ${k === i ? "w-8 bg-[#D4AF37]" : "w-1.5 bg-[#E5E5E5]"}`}
                />
              ))}
            </div>
            <button
              onClick={next}
              data-testid="testimonial-next"
              className="w-10 h-10 rounded-full border border-[#E5E5E5] hover:border-[#D4AF37] flex items-center justify-center transition-colors"
            >
              <ChevronRight className="w-4 h-4" strokeWidth={1.6} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
